import clsx from "clsx";
import { FILTER_ALL } from "../lib/campaignView";

/** Chip-Reihe für Einfachauswahl-Filter („Alle“ + Optionen, optional mit Zähler). */
export function ChipRow<T extends string>({
  label,
  options,
  selected,
  onSelect,
  allLabel = "Alle",
}: {
  label: string;
  options: { key: T; label: string; count?: number }[];
  selected: T | typeof FILTER_ALL;
  onSelect: (key: T | typeof FILTER_ALL) => void;
  allLabel?: string;
}) {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1.5">
      <span className="mr-1 text-xs font-semibold uppercase tracking-wide text-label-tertiary">{label}</span>
      {[{ key: FILTER_ALL as T | typeof FILTER_ALL, label: allLabel }, ...options].map((opt) => (
        <button
          key={opt.key}
          type="button"
          aria-pressed={selected === opt.key}
          className={clsx(
            "inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-medium transition",
            selected === opt.key
              ? "bg-accent text-label-on-accent"
              : "bg-fill-tertiary text-label-secondary hover:bg-fill-secondary hover:text-label",
          )}
          onClick={() => onSelect(opt.key)}
        >
          {opt.label}
          {"count" in opt && typeof opt.count === "number" ? (
            <span className={clsx("tabular-nums", selected === opt.key ? "opacity-80" : "text-label-tertiary")}>
              {opt.count}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  );
}

/** Kennzahl-Kachel, die zugleich als Schnellfilter dient. */
export function KpiTile({
  label,
  value,
  hint,
  active,
  tone = "neutral",
  onClick,
}: {
  label: string;
  value: number;
  hint: string;
  active: boolean;
  tone?: "neutral" | "accent" | "orange" | "green" | "red";
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      title={hint}
      className={clsx(
        "flex flex-col items-start rounded-ios border p-3.5 text-left transition",
        active ? "border-accent bg-accent/10 shadow-ios" : "border-separator bg-card shadow-ios hover:border-accent/40",
      )}
    >
      <span className="text-xs font-semibold uppercase tracking-wide text-label-tertiary">{label}</span>
      <span
        className={clsx(
          "mt-1 text-2xl font-semibold tabular-nums",
          tone === "green" && "text-status-green",
          tone === "orange" && "text-status-orange",
          tone === "red" && "text-status-red",
          tone === "accent" && "text-accent",
          tone === "neutral" && "text-label",
        )}
      >
        {value}
      </span>
      <span className="mt-0.5 text-xs text-label-secondary">{hint}</span>
    </button>
  );
}
